import script from "./FileInputBase64.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileInputBase64.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__